import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import 'vant/lib/index.css';
import 'element-plus/dist/index.css'
// import "@/util/jsmpeg.min.js"

import createFingerprint from './util/getDuid'
createFingerprint()
// import VConsole from 'vconsole';

// 创建 vConsole 实例
// const vConsole = new VConsole();

import mitt from 'mitt';

const app = createApp(App)

app.config.globalProperties.$mitt = mitt()
app.use(createPinia())
app.use(router)

app.mount('#app')
